import PageComponent from "../PageComponent";
import CommonUtil from "../../../../utils/CommonUtil";

class SubControlComponent extends PageComponent {
  constructor(props) {
    super(props);

    this.state = this.initialState(this.state);
  }

  initialState = state => {
    return {
      ...state,
      entity: {}
    };
  };

  removeFromSubArray = element => {
    const { entity } = this.state;

    const filtered = CommonUtil.getDeep(entity, this.getSubArrayPath()).filter(
      item => item.id !== element.id
    );
    CommonUtil.setDeepOnStringPath(entity, this.getSubArrayPath(), filtered);

    this.setState({ entity });
  };

  addToSubArray = element => {
    const { entity } = this.state;

    CommonUtil.getDeep(entity, this.getSubArrayPath()).push(element);

    this.setState({ entity });
  };

  getSubArrayPath = () => {
    throw new Error("You have to implement the method getSubArray!");
  };

  renderProps() {
    return {
      ...super.renderProps(),
      entity: this.state.entity,
      removeFromTable: this.removeFromSubArray,
      addToTable: this.addToSubArray
    };
  }
}

export default SubControlComponent;
